import PwaInstall from './PwaInstall';
import PwaPush from './PwaPush';

// на бой пока не выкатываем
const DEV_HOSTS = ['localhost'];
const DEV_ENV = DEV_HOSTS.includes(window.location.hostname);

const PWA_POPUP_DELAY = 3000;

// pwa popup
const $pwaPopup = $('.js-pwa-popup');

// pwa личный кабинет
const $pwaPersonal = $('.js-pwa-personal');

// скрываемые блоки в зависимости от поддержки pwa фичи
const $push = $('.js-pwa-push');
const $install = $('.js-pwa-install');

// кнопки
const $pushButtons = $('.js-pwa-push-button');
const $installButtons = $('.js-pwa-install-button');


// регистрируем service worker
if ('serviceWorker' in navigator && DEV_ENV) {
    window.addEventListener('load', function() {
        navigator.serviceWorker.register('/sw.js').then(
            () => {
                console.log('[SW] Service worker has been registered');
            },
            e => {
                console.error('[SW] Service worker registration failed', e);
            });
    });
}

// показываем попап один раз
let pwaPopupIsHidden = window.localStorage.pwaPopupIsHidden;

if ($installButtons.length && DEV_ENV) {
    PwaInstall.addCallbacks({
        init: () => {
            $installButtons.on('click', function () {
                PwaInstall.install();
            });
        },
        before: () => {
            $install.removeClass('hidden');
            $pwaPersonal.removeClass('hidden');

            if ($pwaPopup.length && !pwaPopupIsHidden) {
                window.localStorage.setItem('pwaPopupIsHidden', true);

                setTimeout(() => {
                    $pwaPopup.trigger('popup:open', {
                        name: 'pwaPopup'
                    });
                }, PWA_POPUP_DELAY);
            }
        },
        accepted: () => {
            $install.addClass('hidden');
        },
        dismissed: () => {

        },
    });
}

if ($pushButtons.length && DEV_ENV) {
    PwaPush.addCallbacks({
        init: () => {
            $push.removeClass('hidden');
            $pwaPersonal.removeClass('hidden');

            $pushButtons.on('click', function () {
                if (PwaPush.isPushEnabled) {
                    PwaPush.unsubscribe();
                } else {
                    PwaPush.subscribe();
                }
            });

            if ($pwaPopup.length && !pwaPopupIsHidden) {
                window.localStorage.setItem('pwaPopupIsHidden', true);

                setTimeout(() => {
                    $pwaPopup.trigger('popup:open', {
                        name: 'pwaPopup'
                    });
                }, PWA_POPUP_DELAY);
            }
        },
        enabled: (text) => {
            $pushButtons.text(text);
        },
        disabled: (text) => {
            $pushButtons.text(text);
        },
        computing: (text) => {
            $pushButtons.text(text);
        },
        incompatible: (text) => {
            $pushButtons.text(text);
        },
        error: (text) => {
            console.log(text);
        },
    });
}


